import { Component, OnInit } from '@angular/core';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-rg',
  templateUrl: './text-rg.component.html',
  styleUrls: ['./text-rg.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class TextRgComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
}
